import { getKeyClientId } from "./getKeyClientId";
import { safeLocalStorage } from "./safeLocalStorage";
import { cleanText } from "./sanitizeData";

export const getClientIdFromStorage = (): string | null => {
  try {
    const item = safeLocalStorage.getItem(getKeyClientId());
    return item ? cleanText<string>(JSON.parse(item)) : null;
  } catch {
    return null;
  }
};
